import fileSys from "../../fileoprators/fileSystem";
let CameraNode = {
  CameraInit: () => {
    return {};
  },
  MallocNetPtr() {},
  NIBUTSetDisplay() {},
  NIBUTSHOTClear() {},
  BUTSHOTClear() {},
  BUTSHOTGet() {},
  MwGetXYZPoints() {},
  CameraSetWB: () => {},
  CameraSetCallback: (callback) => {},
  CameraStopRecord: (cam) => {},
  NIBUTStart: () => {},
  BLINKStart: () => {},
  BLINKClear: () => {},
  BLINKSetParams: () => {},
  BLINKStatistics() {
    return undefined;
  },
  BLINKClose: () => {},
  NIBUTSetParams: () => {},
  LipidStart: () => {},
  LipidLocClear: () => {},
  LipidLocClose: () => {},
  LipidSetParams: () => {},
  LipidGetReportImg() {
    return undefined;
  },
  camera_close: () => {},
  NibutStatistic() {
    return undefined;
  },
  CameraStartRecord: (cam, mp4Path, jpgPath) => {
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), jpgPath);
    fileSys.copyFile(fileSys.getMockPath("test.mp4"), mp4Path);
  },
  CameraTakePhoto: (cam, filepath, callback) => {
    fileSys.copyFile(fileSys.getMockPath("test.jpg"), filepath);
    if (callback) callback();
  },
  CameraClose: () => {}
};
export default CameraNode;



// WEBPACK FOOTER //
// ./src/mainInterface/js/CameraNode.js